import React, { useEffect, useState } from 'react';
import './FullScreenLoader.scss';
import classNames from 'classnames';

interface FullScreenLoaderProps {
    message?: string;
    highlightedText?: string;
    size?: 'sm' | 'lg';
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
    message = 'Loading...',
    highlightedText,
    size = 'lg',
}) => {
    const [progress, setProgress] = useState(0);
    const duration = 2000;

    useEffect(() => {
        let start: number | null = null;
        const step = (timestamp: number) => {
            if (!start) start = timestamp;
            const elapsed = timestamp - start;
            const progressValue = Math.min(100, (elapsed / duration) * 100);
            setProgress(progressValue);
            if (progressValue < 100) {
                requestAnimationFrame(step);
            }
        };
        requestAnimationFrame(step);
    }, [duration]);

    return (
        <div className="FullScreenLoader d-flex align-items-center justify-content-center">
            <div className="text-center px-4 col-10">
                <div className="FullScreenLoader__logo mb-4">
                    <img
                        src="https://s3.amazonaws.com/nsi-logos/Northspyre_loading_logo.gif"
                        alt="loading-logo"
                        className={classNames([
                            'NSLoadingScreen__img',
                            {
                                'NSLoadingScreen__img--sm': size === 'sm',
                                'NSLoadingScreen__img--lg': size === 'lg',
                            },
                        ])}
                    />
                </div>
                <div className="text-white mb-4 font-20">
                    <span className="font-weight-normal">{message}</span>
                    {highlightedText && (
                        <span className="font-weight-bold">{highlightedText}</span>
                    )}
                </div>
                <div className="FullScreenLoader__progress w-100">
                    <div
                        className="FullScreenLoader__progress-bar h-100"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    />
                </div>
            </div>
        </div>
    );
};

export default FullScreenLoader;
